import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { object, string, mixed } from 'yup';

import Cabecalho from 'Component/Admin/Cabecalho';
import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Form, { Arquivo, Botao, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import Categoria from 'Interface/Categorias';
import { useEditarCategoriaMutation, useRecuperarCategoriaQuery } from 'Service';

const regras = object({
    nome: string().required('Obrigatório'),
    slug: string().required('Obrigatório'),
    imagem: mixed()
        .test('tamanho', 'O arquivo é muito grande', valor => {
            if (valor && valor.size) {
                return valor.size <= 500000;
            }
            return true;
        })
        .test('tipo', 'Formato não suportado', valor => {
            if (valor && valor.type) {
                return ['image/png', 'image/jpeg', 'image/webp'].includes(valor.type)
            }
            return true;
        })
        .optional(),
});

const Editar = (): React.ReactElement =>
{
    const navegacao = useNavigate();
    const toast = useToast();
    const { id = 0 } = useParams<'id'>();
    const { data, isLoading } = useRecuperarCategoriaQuery(id);
    const [ editarCategoria ] = useEditarCategoriaMutation();

    const enviar = async (dados: Categoria): Promise<void> =>
    {
        try {
            await editarCategoria(dados).unwrap();

            toast({ conteudo: 'Editado com sucesso!', tema: 'success' });

            navegacao('/admin/categorias');
        } catch (error) {
            toast({
                titulo: 'Erro ao editar',
                conteudo: 'Verifique os logs para maiores detalhes.',
                tema: 'danger',
            });
        }
    }

    return (
        <div className="animate__animated animate__fadeIn">
            <Cabecalho
                titulo="Editando categoria"
                descricao="Altere o formulário e clique em enviar para editar a categoria"
            />
            <Form onSubmit={ enviar } inicial={ data?.categoria } desabilitado={ isLoading } regras={ regras }>
                <div className="row justify-content-center">
                    <div className="col-md-4">
                        <div className="bg-white shadow-sm rounded p-4">
                            <div className="mb-5 d-flex justify-content-center">
                                <Imagem
                                    src={ data?.categoria.imagem }
                                    alt={ data?.categoria.nome }
                                    className="rounded-circle object-fit-cover shadow-lg"
                                    width="100"
                                    height="100"
                                />
                            </div>
                            <Arquivo name="imagem" />
                            <Campo name="nome" rotulo="Nome" />
                            <Campo name="slug" rotulo="Slug para URL amigável" prefixar={<Icone nome="globe" />} />
                            <div className="mt-5">
                                <Botao>Enviar</Botao>
                                <BotaoLink tema="light" to="/admin/categorias" className="ms-2">
                                    Cancelar
                                </BotaoLink>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default Editar;
